/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_AllocatableInputs */

const en_admin_resources_allocatable = /** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocatable`)
};

const de_admin_resources_allocatable = /** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisbar`)
};

const es_admin_resources_allocatable = /** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignable`)
};

const fr_admin_resources_allocatable = /** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribuable`)
};

/** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */
const it_admin_resources_allocatable = en_admin_resources_allocatable;

/** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */
const pt_br2_admin_resources_allocatable = en_admin_resources_allocatable;

/** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */
const pl_admin_resources_allocatable = en_admin_resources_allocatable;

/** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */
const hu_admin_resources_allocatable = en_admin_resources_allocatable;

/** @type {(inputs: Admin_Resources_AllocatableInputs) => LocalizedString} */
const ro_admin_resources_allocatable = en_admin_resources_allocatable;

/**
* | output |
* | --- |
* | "Allocatable" |
*
* @param {Admin_Resources_AllocatableInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_allocatable = /** @type {((inputs?: Admin_Resources_AllocatableInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_AllocatableInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_allocatable(inputs)
	if (locale === "de") return de_admin_resources_allocatable(inputs)
	if (locale === "es") return es_admin_resources_allocatable(inputs)
	if (locale === "fr") return fr_admin_resources_allocatable(inputs)
	if (locale === "it") return it_admin_resources_allocatable(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_allocatable(inputs)
	if (locale === "pl") return pl_admin_resources_allocatable(inputs)
	if (locale === "hu") return hu_admin_resources_allocatable(inputs)
	return ro_admin_resources_allocatable(inputs)
});
export { admin_resources_allocatable as "admin.resources.allocatable" }